<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="1200px"
    v-if="isDataLoadedFromServer"
    style="background-color: white !important; height: 80vh !important"
  >
    <div class="bg-white poppins modal-root">
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">
          Edit Order ({{ serverData.data[1].data[1].value }})
        </h4>
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
      </div>

      <div class="d-block pa-4">
        <!--begin::Body-->
        <v-stepper
          v-model="tab"
          non-linear
          v-if="isStepperReady"
          @change="updateValidationStateOfSteps"
        >
          <v-stepper-header class="step-head-main">
            <v-stepper-step
              v-for="(item, i) in categories"
              :key="i"
              class="step-head"
              editable
              complete
              complete-icon="mdi-check-circle"
              edit-icon="mdi-check"
              error-icon="mdi-alert-circle"
              :step="i"
              :rules="[
                () => {
                  return item.valid;
                },
              ]"
            >
              {{ item.name }}
              <small v-if="!item.valid">Invalid</small>
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="0" class="pt-2">
              <v-card color="basil" flat>
                <pop-up-time-line
                  :item="getItemData('timeline', 'Status history')"
                />
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="1" class="pt-2">
              <v-card color="basil" flat class="row pt-4">
                <div class="col-12 col-sm-6">
                  <v-text-field
                    class
                    v-model="$v.consignee.consignee_name.$model"
                    :label="$t('consignee_name')"
                    clearable
                    outlined
                    dense
                    :error-messages="consignee_nameErrors"
                    @input="$v.consignee.consignee_name.$touch()"
                    @blur="$v.consignee.consignee_name.$touch()"
                  />
                </div>
                <div class="col-12 col-sm-6">
                  <v-text-field
                    v-model="$v.consignee.consignee_phone.$model"
                    :label="$t('consignee_phone')"
                    clearable
                    outlined
                    dense
                    :error-messages="consignee_phoneErrors"
                    @input="$v.consignee.consignee_phone.$touch()"
                    @blur="$v.consignee.consignee_phone.$touch()"
                  />
                </div>
                <div class="col-12 col-sm-6">
                  <v-text-field
                    v-model="$v.consignee.consignee_mobile.$model"
                    :label="$t('consignee_mobile')"
                    clearable
                    outlined
                    dense
                    :error-messages="consignee_mobileErrors"
                    @input="$v.consignee.consignee_mobile.$touch()"
                    @blur="$v.consignee.consignee_mobile.$touch()"
                  />
                </div>
                <div class="col-12 col-sm-6">
                  <v-text-field
                    v-model="consignee.consignee_email"
                    :label="$t('consignee_email')"
                    clearable
                    outlined
                    dense
                  />
                </div>
                <div class="col-12 col-sm-6">
                  <v-text-field
                    class
                    v-model="consignee.consignee_document_number"
                    :label="$t('consignee_id')"
                    clearable
                    outlined
                    dense
                  />
                </div>
                <div class="col-12 col-md-6">
                  <OrderSingleDatePicker
                    :value="consignee.consignee_birthday"
                    :label="$t('consignee_birthday')"
                    :clearDate="
                      () => {
                        consignee.consignee_birthday = null;
                      }
                    "
                    @on-date-submit="
                      (date) => {
                        consignee.consignee_birthday = date ?? null;
                      }
                    "
                    class="poppins"
                  />
                </div>
                <div class="col-12 col-sm-6">
                  <v-select
                    v-model="order_details.consignee_document_type_id"
                    :label="$t('consignee_document_type')"
                    item-text="text"
                    item-value="index"
                    :items="serverData.document_types"
                    clearable
                    outlined
                    dense
                  />
                </div>
                <div class="col-12 col-sm-6">
                  <v-select
                    v-model="order_details.consignee_document_country_id"
                    :label="$t('consignee_document_country')"
                    item-text="text"
                    item-value="index"
                    :items="serverData.countries"
                    clearable
                    outlined
                    dense
                  />
                </div>
                <div class="col-12 col-md-6">
                  <OrderSingleDatePicker
                    :value="consignee.consignee_document_issue_date"
                    :label="$t('consignee_document_issue_date')"
                    :clearDate="
                      () => {
                        consignee.consignee_document_issue_date = null;
                      }
                    "
                    @on-date-submit="
                      (date) => {
                        consignee.consignee_document_issue_date = date ?? null;
                      }
                    "
                    class="poppins"
                  />
                </div>
                <div class="col-12 col-sm-6">
                  <OrderSingleDatePicker
                    :value="consignee.consignee_document_expiry_date"
                    :label="$t('consignee_document_expiry_date')"
                    :min="new Date().toLocaleDateString()"
                    :clearDate="
                      () => {
                        consignee.consignee_document_expiry_date = null;
                      }
                    "
                    @on-date-submit="
                      (date) => {
                        consignee.consignee_document_expiry_date = date ?? null;
                      }
                    "
                    class="poppins"
                  />
                </div>
                <div
                  class="col-12 col-sm-6"
                  v-if="serverData.order.consignee_document_url !== ''"
                >
                  <v-btn
                    elevation="0"
                    @click="
                      showConsigneeDetails(
                        serverData.order.consignee_document_url
                      )
                    "
                    >VIEW DOCUMENT DETAILS</v-btn
                  >
                </div>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="2" class="pt-2">
              <v-card color="basil" flat class="row pt-4">
                <div class="col-12 col-sm-6 col-md-3">
                  <v-select
                    v-model="order_details.warehouse"
                    :label="$t('warehouse')"
                    item-text="text"
                    item-value="index"
                    :items="serverData.warehouses"
                    clearable
                    outlined
                    dense
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                  <v-select
                    v-model="order_details.order_type"
                    :label="$t('order_type')"
                    item-text="text"
                    item-value="index"
                    :items="serverData.order_types"
                    clearable
                    outlined
                    dense
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                  <v-select
                    v-model="order_details.carrier_id"
                    :label="$t('carrier')"
                    item-text="text"
                    item-value="index"
                    :items="serverData.carriers"
                    clearable
                    outlined
                    dense
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                  <v-text-field
                    class
                    v-model="order_details.awb"
                    :label="$t('awb')"
                    clearable
                    outlined
                    dense
                  />
                </div>

                <div class="col-12 col-sm-6 col-md-3">
                  <v-select
                    v-model="order_details.shipping_method"
                    :label="$t('shipping_method')"
                    item-text="text"
                    item-value="index"
                    :items="serverData.shipping_types"
                    clearable
                    outlined
                    dense
                    :error-messages="shipping_methodErrors"
                    @input="$v.order_details.shipping_method.$touch()"
                    @blur="$v.order_details.shipping_method.$touch()"
                  />
                </div>

                <div class="col-12 col-sm-6 col-md-3">
                  <v-select
                    v-model="order_details.payment_type"
                    :label="$t('payment_type')"
                    item-text="text"
                    item-value="index"
                    :items="serverData.payment_types"
                    clearable
                    outlined
                    dense
                    :error-messages="payment_typeErrors"
                    @input="$v.order_details.payment_type.$touch()"
                    @blur="$v.order_details.payment_type.$touch()"
                  />
                </div>

                <div
                  v-if="order_details.payment_type === 1"
                  class="col-12 col-sm-6 col-md-3"
                >
                  <v-select
                    v-model="order_details.payment_mode"
                    :label="$t('payment_mode')"
                    item-text="text"
                    item-value="index"
                    :items="serverData.payment_modes"
                    clearable
                    outlined
                    dense
                    :error-messages="payment_modesErrors"
                    @input="$v.order_details.payment_mode.$touch()"
                    @blur="$v.order_details.payment_mode.$touch()"
                  />
                </div>

                <div class="col-12 col-sm-6 col-md-3">
                  <v-select
                    v-model="order_details.currency"
                    :label="$t('currency')"
                    item-text="text"
                    item-value="index"
                    :items="serverData.currencies"
                    clearable
                    outlined
                    dense
                    :error-messages="currencyErrors"
                    @input="$v.order_details.currency.$touch()"
                    @blur="$v.order_details.currency.$touch()"
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                  <v-text-field
                    v-model="order_details.total_price"
                    :label="$t('total_price')"
                    type="Number"
                    clearable
                    dense
                    outlined
                    :error-messages="total_priceErrors"
                    @input="$v.order_details.total_price.$touch()"
                    @blur="$v.order_details.total_price.$touch()"
                    @change="
                      () => validateMinValue('total_price', 0, 'order_details')
                    "
                  />
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                  <v-text-field
                    v-model="order_details.parcel_weight"
                    :label="$t('parcel_weight')"
                    clearable
                    outlined
                    dense
                    type="number"
                    :error-messages="parcel_weightErrors"
                    @input="$v.order_details.parcel_weight.$touch()"
                    @blur="$v.order_details.parcel_weight.$touch()"
                    @change="
                      () =>
                        validateMinValue('parcel_weight', 0, 'order_details')
                    "
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <v-text-field
                    v-model="order_details.parcel_volume"
                    :label="$t('parcel_volume')"
                    clearable
                    outlined
                    dense
                    type="number"
                    :error-messages="parcel_volumeErrors"
                    @input="$v.order_details.parcel_volume.$touch()"
                    @blur="$v.order_details.parcel_volume.$touch()"
                    @change="
                      () =>
                        validateMinValue('parcel_volume', 0, 'order_details')
                    "
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <v-text-field
                    v-model="order_details.number_of_boxes"
                    :label="$t('number_of_boxes')"
                    :min="0"
                    clearable
                    outlined
                    dense
                    type="number"
                    :error-messages="number_of_boxesErrors"
                    @input="$v.order_details.number_of_boxes.$touch()"
                    @blur="$v.order_details.number_of_boxes.$touch()"
                    @change="
                      () =>
                        validateMinValue('number_of_boxes', 0, 'order_details')
                    "
                  />
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                  <v-text-field
                    v-model="order_details.shipping_price"
                    :label="$t('shipping_price')"
                    type="Number"
                    :min="0"
                    clearable
                    outlined
                    dense
                    @change="
                      () =>
                        validateMinValue('shipping_price', 0, 'order_details')
                    "
                  />
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                  <v-text-field
                    v-model="order_details.customs_value"
                    :label="$t('customs_value')"
                    type="Number"
                    :min="0"
                    clearable
                    outlined
                    dense
                    @change="
                      () =>
                        validateMinValue('customs_value', 0, 'order_details')
                    "
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <v-text-field
                    v-model="order_details.subtotal"
                    :label="$t('subtotal')"
                    type="Number"
                    :min="0"
                    clearable
                    outlined
                    dense
                    @change="
                      () => validateMinValue('subtotal', 0, 'order_details')
                    "
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <v-text-field
                    v-model="order_details.total_discount"
                    :label="$t('total_discount')"
                    type="Number"
                    :min="0"
                    clearable
                    outlined
                    dense
                    @change="
                      () =>
                        validateMinValue('total_discount', 0, 'order_details')
                    "
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <v-text-field
                    v-model="order_details.total_tax"
                    :label="$t('total_tax')"
                    type="Number"
                    :min="0"
                    clearable
                    outlined
                    dense
                    @change="
                      () => validateMinValue('total_tax', 0, 'order_details')
                    "
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <v-text-field
                    v-model="order_details.tax_percentage"
                    :label="$t('tax_percentage')"
                    type="Number"
                    :min="0"
                    clearable
                    outlined
                    dense
                    @change="
                      () =>
                        validateMinValue('tax_percentage', 0, 'order_details')
                    "
                  />
                </div>

                <div class="col-12 col-sm-6 col-md-4">
                  <v-text-field
                    v-model="order_details.total_declared_amount"
                    :label="$t('total_declared_amount')"
                    type="Number"
                    :min="0"
                    clearable
                    outlined
                    dense
                    @change="
                      () =>
                        validateMinValue(
                          'total_declared_amount',
                          0,
                          'order_details'
                        )
                    "
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <v-text-field
                    v-model="order_details.cod_amount"
                    :label="$t('cod_amount')"
                    type="Number"
                    :min="0"
                    clearable
                    outlined
                    dense
                    @change="
                      () => validateMinValue('cod_amount', 0, 'order_details')
                    "
                    :error-messages="cod_amountErrors"
                    @input="$v.order_details.cod_amount.$touch()"
                    @blur="$v.order_details.cod_amount.$touch()"
                  />
                </div>

                <!-- <div class="col-12 col-sm-6 col-md-4">
                  <v-checkbox
                    :label="$t('skip_rule_validation')"
                    v-model="order_details.skip_oms_rules"
                    outlined
                    dense
                  />
                </div> -->

                <div class="col-12">
                  <v-text-field
                    v-model="order_details.comment"
                    :label="$t('comment')"
                    clearable
                    outlined
                    dense
                  />
                </div>
                <div class="col-12">
                  <v-text-field
                    v-model="order_details.gift_message"
                    :label="$t('gift_message')"
                    clearable
                    outlined
                    dense
                  />
                </div>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="3" class="pt-2">
              <v-card color="basil" flat>
                <pop-up-table :item="getItemData('table', 'Call History')" />
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="4" class="pt-2">
              <div class="row pt-4">
                <div class="col-12 col-sm-6">
                  <v-autocomplete
                    @change="onCountryChange"
                    v-model="$v.address.country_id.$model"
                    :label="$t('country')"
                    item-text="text"
                    item-value="index"
                    :items="serverData.countries"
                    outlined
                    dense
                    :error-messages="country_idErrors"
                    @input="$v.address.country_id.$touch()"
                    @blur="$v.address.country_id.$touch()"
                  />
                </div>
                <div class="col-12 col-sm-6">
                  <v-autocomplete
                    ref="stateCombo"
                    v-model="$v.address.state.$model"
                    :search-input.sync="state_text"
                    :items="serverData.states"
                    :disabled="isStatesLoaded"
                    item-text="title"
                    item-value="title"
                    :label="
                      oldValueText('state')
                        ? 'State (' + oldValueText('state') + ')'
                        : 'State'
                    "
                    outlined
                    required
                    dense
                    :append-outer-icon="
                      serverData?.order?.state ? 'mdi-content-copy' : ''
                    "
                    @click:append-outer="copyAddress(serverData?.order?.state)"
                    :error-messages="stateErrors"
                    @input="$v.address.state.$touch()"
                    @blur="$v.address.state.$touch()"
                  >
                    <template v-slot:append-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            <button
                              class="btn btn-info pl-2"
                              @click="
                                () =>
                                  createNewItem(
                                    'state',
                                    address.country_id,
                                    onCountryChange,
                                    state_text
                                  )
                              "
                            >
                              Create new
                            </button>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            No data available
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
                <div class="col-12 col-sm-6">
                  <v-autocomplete
                    ref="cityCombo"
                    v-model="$v.address.city.$model"
                    :search-input.sync="city_text"
                    :items="serverData.cities"
                    :disabled="isCitiesLoaded"
                    item-text="title"
                    item-value="title"
                    outlined
                    required
                    dense
                    :label="
                      oldValueText('city')
                        ? 'City (' + oldValueText('city') + ')'
                        : 'City'
                    "
                    :append-outer-icon="
                      serverData?.order?.city ? 'mdi-content-copy' : ''
                    "
                    @click:append-outer="copyAddress(serverData?.order?.city)"
                    :error-messages="cityErrors"
                    @input="$v.address.city.$touch()"
                    @blur="$v.address.city.$touch()"
                  >
                    <template v-slot:append-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            <button
                              class="btn btn-info pl-2"
                              @click="
                                () =>
                                  createNewItem(
                                    'city',
                                    address.state.id,
                                    onStateChange,
                                    city_text
                                  )
                              "
                            >
                              Create new
                            </button>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            No data available
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
                <div class="col-12 col-sm-6">
                  <v-autocomplete
                    ref="areaCombo"
                    :disabled="isAreasLoaded"
                    v-model="address.area"
                    :search-input.sync="area_text"
                    :items="serverData.areas"
                    item-text="title"
                    item-value="id"
                    :label="
                      oldValueText('area')
                        ? 'Area (' + oldValueText('area') + ')'
                        : 'Area'
                    "
                    persistent-hint
                    outlined
                    return-object
                    dense
                    :append-outer-icon="
                      serverData?.order?.area ? 'mdi-content-copy' : ''
                    "
                    @click:append-outer="copyAddress(serverData?.order?.area)"
                    :error-messages="areaErrors"
                    @input="$v.address.area.$touch()"
                    @blur="$v.address.area.$touch()"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            <button
                              class="btn btn-info pl-2"
                              @click="
                                () =>
                                  createNewItem(
                                    'area',
                                    address.city.id,
                                    onCityChange,
                                    area_text
                                  )
                              "
                            >
                              Create new
                            </button>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>

                <div class="col-12 col-sm-6">
                  <v-text-field
                    v-model="address.province"
                    :label="$t('province')"
                    clearable
                    outlined
                    dense
                  />
                </div>
                <div class="col-12 col-sm-6">
                  <v-text-field
                    v-model="address.town"
                    :label="$t('town')"
                    clearable
                    outlined
                    dense
                  />
                </div>
                <div class="col-12 col-sm-6">
                  <v-text-field
                    v-model="address.address"
                    :label="$t('address')"
                    clearable
                    outlined
                    dense
                    :error-messages="addressErrors"
                    @input="$v.address.address.$touch()"
                    @blur="$v.address.address.$touch()"
                  />
                </div>
                <div class="col-12 col-sm-6">
                  <v-text-field
                    v-model="address.short_address"
                    :label="$t('short_address')"
                    clearable
                    outlined
                    dense
                    maxlength="8"
                    counter="8"
                    @paste="handlePaste"
                  />
                </div>
                <div class="col-12 col-sm-6">
                  <v-text-field
                    v-model="address.zipcode"
                    :label="$t('zipcode')"
                    clearable
                    outlined
                    dense
                  />
                </div>
              </div>
            </v-stepper-content>
            <v-stepper-content step="5" class="pt-2">
              <v-card color="basil" flat>
                <pop-up-text-group
                  :item="getItemData('text', 'Current status')"
                />
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="6" class="pt-2">
              <v-card color="basil" flat>
                <v-col cols="12">
                  <sku-datatable
                    :setSku="setSkus"
                    :skus="formData.skus"
                    :skuItem="serverData.skus"
                    :clientId="serverData.order.client_id"
                    :is_unit_price_editable="
                      serverData?.order?.is_sku_price_updatable
                    "
                  />
                </v-col>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <!--end::Body-->
        <CreateLocation
          :location-id="getLocationId"
          :location-type="getLocationType"
          :location-function="getLocationFunc"
          :locationSetValue="setTextValue"
          :initValue="getLocationInitValue"
          ref="location"
        />

        <div class="d-flex justify-content-between mt-5 mb-2">
          <div>
            <v-btn
              width="120"
              @click="showPrevOrder(serverData.order.id)"
              class="order-4 order-sm-1"
              >previous
            </v-btn>
          </div>

          <div>
            <button
              type="reset"
              class="btn btn-light-danger px-5 py-3 order-3 order-sm-2"
              @click="showCancelModal"
            >
              Cancel Order
            </button>
            <button
              type="submit"
              class="btn btn-warning px-5 py-3 order-2 order-sm-3 mx-3"
              @click="showHoldOnModal"
            >
              {{
                serverData.order.last_status_id === 1340
                  ? "Update info and Release"
                  : "On Hold"
              }}
            </button>
            <button
              v-if="serverData.order.last_status_id !== 1340"
              type="submit"
              class="btn btn-info px-5 py-3 order-1 order-sm-4"
              @click="submitEditForm"
            >
              Update info and Audit
            </button>
          </div>
          <v-snackbar v-model="snackbar">
            {{ snackbarText }}

            <template v-slot:action="{ attrs }">
              <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
                Close
              </v-btn>
            </template>
          </v-snackbar>
          <div>
            <v-btn
              width="120"
              @click="() => showNextOrder(serverData.order.id)"
              class="order-5 order-sm-5"
              >next
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="dialog2" scrollable max-width="300px">
      <v-card>
        <v-card-title>Select Hold On Reason</v-card-title>
        <v-divider />
        <v-card-text style="height: 300px">
          <v-radio-group v-model="holdOn_reason" column>
            <v-radio
              v-for="item in extraData.hold_reasons"
              :label="item.text"
              :value="item.index"
              :key="item.value"
            />
          </v-radio-group>

          <v-menu
            v-if="holdOn_reason === 1030"
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="holdOn_date"
                :label="$t('date')"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker v-model="holdOn_date" @input="menu2 = false" />
          </v-menu>
        </v-card-text>
        <v-divider />
        <v-card-actions class="d-flex justify-end">
          <v-btn color="blue darken-1" text @click="dialog2 = false">
            Close
          </v-btn>
          <v-btn color="blue darken-1" text @click="actionOnHold">
            On hold
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog3" scrollable max-width="300px">
      <v-card>
        <v-card-title>Cancel Reason</v-card-title>
        <v-divider />
        <v-card-text style="height: 300px">
          <v-radio-group v-model="cancel_reason" column>
            <v-radio
              v-for="item in extraData.cancel_reasons"
              :label="item.text"
              :value="item.index"
              :key="item.value"
            />
          </v-radio-group>
        </v-card-text>
        <v-divider />
        <v-card-actions class="d-flex justify-end">
          <v-btn color="blue darken-1" text @click="dialog3 = false">
            Close
          </v-btn>
          <v-btn color="blue darken-1" text @click="actionCancel">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";
import SkuDatatable from "@/own/components/orderManagement/pendingAuditOrders/skuContainer/SkuDatatable";

import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import PopUpTimeLine from "@/own/components/fulfillment/orders/popup/PopUpTimeLine";
import PopUpTable from "@/own/components/fulfillment/orders/popup/PopUpTable";
import PopUpTextGroup from "@/own/components/fulfillment/orders/popup/PopUpTextGroup";

import CreateLocation from "./CreateLocation.vue";

import fieldValueValidation from "@/own/mixins/fieldValueValidation.js";

import {
  handleCityValueChange,
  handleCountryValueChange,
  handleStateValueChange,
} from "@/own/libs/handle-locations";
import OrderSingleDatePicker from "@/own/components/fulfillment/orders/OrderSingleDatePicker.vue";

const hasValue = (value) =>
  value !== null && value !== undefined && value !== "";

const hasSameAmount = (value, comparedValue) => {
  if (!hasValue(value) || !hasValue(comparedValue)) {
    return true;
  }

  return Number.parseFloat(value) === Number.parseFloat(comparedValue);
};

export default {
  name: "EditItem",
  mixins: [validationMixin, fieldValueValidation],
  components: {
    PopUpTextGroup,
    PopUpTimeLine,
    SkuDatatable,
    PopUpTable,
    CreateLocation,
    OrderSingleDatePicker,
  },
  props: {
    itemForAction: {
      required: false,
      type: Number,
    },
    refresher: {
      required: true,
      type: Function,
    },
    pageLoader: {
      required: true,
      type: Function,
    },
    extraData: {
      required: true,
      type: Object,
    },
    showNextOrder: {
      required: true,
      type: Function,
    },
    showPrevOrder: {
      required: true,
      type: Function,
    },
  },
  validations() {
    return {
      address: {
        address: { required },
        city: { required },
        state: { required },
        area: { required },
        country_id: { required },
      },
      consignee: {
        consignee_name: { required },
        consignee_phone: { required },
        consignee_mobile: { required },
      },
      order_details: {
        shipping_method: { required },
        payment_type: { required },
        payment_mode: {
          required: requiredIf(function () {
            return this.order_details.payment_type === 1;
          }),
        },
        currency: { required },
        total_price: {
          required: requiredIf(function () {
            return (
              this.order_details.payment_type === 1 ||
              this.order_details.country_id !== 229
            );
          }),
        },
        parcel_weight: {
          required: requiredIf(function () {
            return (
              this.order_details.order_type === 9 ||
              this.order_details.order_type === 1
            );
          }),
        },
        parcel_volume: {
          required: requiredIf(function () {
            return (
              this.order_details.order_type === 9 ||
              this.order_details.order_type === 1
            );
          }),
        },
        number_of_boxes: {
          required: requiredIf(function () {
            return (
              this.order_details.order_type === 9 ||
              this.order_details.order_type === 17
            );
          }),
        },
        cod_amount: {
          required: requiredIf(function () {
            return this.order_details.payment_type === 1;
          }),
          sameAs: (value) => {
            if (this.order_details.payment_type !== 1) {
              return true;
            }

            return hasSameAmount(value, this.order_details.total_price);
          },
        },
      },
    };
  },
  data: () => ({
    areaMessage: "",

    state_text: "",
    city_text: "",
    area_text: "",

    old_address: {
      state: null,
      city: null,
      area: null,
    },

    location_type: null,
    locaiton_id: null,
    location_function: null,
    location_initValue: null,

    // old_address: {
    //   state: null,
    //   city: null,
    //   area: null,
    // },

    formData: {
      id: null,

      skus: [],
    },
    address: {
      address: null,
      area: null,
      province: null,
      town: null,
      city: null,
      state: null,
      country_id: null,
      zipcode: null,
      short_address: null,
    },
    consignee: {
      consignee_name: null,
      consignee_phone: null,
      consignee_mobile: null,
      consignee_email: null,
      consignee_document_number: null,
      consignee_document_type_id: null,
      consignee_document_country_id: null,
      consignee_document_expiry_date: null,
      consignee_document_issue_date: null,
      consignee_birthday: null,
    },
    order_details: {
      awb: null,
      // skip_oms_rules: false,
      warehouse: null,
      carrier_id: null,
      comment: null,
      total_price: null,
      currency: null,
      payment_type: null,
      payment_mode: 1,
      shipping_method: null,
      order_type: null,
      parcel_weight: null,
      parcel_volume: null,
      number_of_boxes: null,
      gift_message: null,
      shipping_price: null,
      total_tax: null,
      tax_percentage: null,
      subtotal: null,

      customs_value: null,
      total_discount: null,
      total_declared_amount: null,
      cod_amount: null,
    },

    dialog2: false,
    dialog3: false,
    dialog: false,
    menu2: false,
    cancel_reason: null,
    holdOn_reason: null,
    holdOn_date: null,
    serverData: null,
    tab: 0,

    updateValueTimer: setTimeout(() => {}, 0),
    cityFetchTimer: null,
    areaFetchTimer: null,
    locationFetchTriggerTime: 600,
    snackbar: false,
    snackbarText: "",
  }),
  methods: {
    handlePaste(event) {
      event.preventDefault();
      const pastedText = (event.clipboardData || window.clipboardData).getData(
        "text"
      );
      const cleanedText = pastedText.trim().substring(0, 8);
      this.address.short_address = cleanedText;
    },
    showConsigneeDetails(url) {
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.download = "orders.csv";
      link.click();
    },
    oldValueText(type) {
      let message = "";
      switch (type) {
        case "state":
          if (this.old_address?.state) {
            message = `Received: ${this.old_address.state}`;
          }

          break;
        case "city":
          if (this.old_address?.city) {
            message = `Received: ${this.old_address.city}`;
          }
          break;
        case "area":
          if (this.old_address?.area) {
            message = `Received: ${this.old_address.area}`;
          }
          break;
      }
      return message;
    },
    updateValue(type) {
      clearTimeout(this.updateValueTimer);
      this.updateValueTimer = setTimeout(() => {
        this.onBlurValueCheck(type);
      }, this.locationFetchTriggerTime);
    },
    async onBlurValueCheck(type) {
      switch (type) {
        case "state": {
          if (this.state_text == "") {
            return;
          }

          const item = this.serverData?.states?.find(
            (state) => state.title === this.state_text
          );

          if (!item) {
            this.serverData.cities = null;
            this.serverData.areas = null;
          } else {
            if (item.title != this.state_text) {
              this.state_text = item.title;
            } else {
              await this.onStateChange(item.title);
              this.$refs.stateCombo.blur();
            }
          }

          break;
        }
        case "city": {
          if (this.city_text == "") {
            return;
          }

          const item = this.serverData?.cities?.find(
            (city) => city.title === this.city_text
          );
          if (!item) {
            this.serverData.areas = null;
          } else {
            if (item.title != this.city_text) {
              this.city_text = item.title;
            } else {
              await this.onCityChange(item.title);
              this.$refs.cityCombo.blur();
            }
          }

          break;
        }
      }
    },
    validationValueCheck(type) {
      let validation = null;
      switch (type) {
        case "state":
          if (this.state_text == "") {
            return;
          }
          try {
            if (
              !this.serverData?.states?.find(
                (state) => state.title === this.state_text
              )
            ) {
              validation = "Please, select valid state!";
              // this.serverData.cities = null;
              // this.serverData.areas = null;
            }
          } catch {
            validation = "Please, select valid state!";
          }

          break;
        case "city":
          if (this.city_text == "") {
            return;
          }
          try {
            if (
              !this.serverData?.cities?.find(
                (city) => city.title === this.city_text
              )
            ) {
              validation = "Please, select valid city!";
              // this.serverData.areas = null;
            }
          } catch {
            validation = "Please, select valid state!";
          }

          break;
        case "area":
          try {
            if (
              !this.serverData.areas.find(
                (area) => area.title === this.area_text
              )
            ) {
              validation = "Please, select valid area!";
            }
          } catch {
            validation = "Please, select valid city!";
          }
          break;
      }
      return validation;
    },
    setTextValue(type, value = "") {
      switch (type) {
        case "state":
          this.state_text = value;
          if (value == "") {
            return;
          }
          const state = this.serverData?.states?.find(
            (state) => state.title === this.state_text
          );
          this.address.state = state;
          // this.onStateChange(this.address.state.title);

          break;
        case "city":
          this.city_text = value;
          if (value == "") {
            return;
          }
          const city = this.serverData?.cities?.find(
            (city) => city.title === this.city_text
          );
          if (city) {
            this.address.city = city;
          }

          // this.onCityChange(this.address.city.title);

          break;
        case "area":
          this.area_text = value;

          if (value == "") {
            return;
          }
          const area = this.serverData?.areas?.find(
            (area) => area.title === this.area_text
          );
          if (area) {
            this.address.area = area;
          }

          break;
      }
    },
    createNewItem(type, id, func, value) {
      this.$refs[`${type}Combo`].blur();
      this.location_type = type;
      this.locaiton_id = id;
      this.location_function = func;
      this.location_initValue = value;
      this.$nextTick(() => {
        this.$refs.location.toggleModal();
      });
    },
    updateValidationStateOfSteps() {
      this.$v.$touch();
      this.categories.forEach((cat) => {
        cat.valid = !cat.rules(this);
      });
    },
    resetValidationStateOfSteps() {
      this.categories.forEach((cat) => {
        cat.valid = true;
      });
    },
    getItemData(type, title) {
      return this.infoData.find(
        (data) => data.type === type && data.title === title
      );
    },
    actionUpdateAndAudit() {},
    showCancelModal() {
      this.dialog3 = !this.dialog3;
    },
    actionCancel() {
      if (this.cancel_reason) {
        this.pageLoader(true);
        this.dialog3 = false;
        const data = {
          order_ids: [this.itemForAction],
          reason: this.cancel_reason,
        };
        ApiService.post(`/order_management/pending_audit_orders/cancel`, data)
          .then(() => {
            Swal.fire({
              title: "Updated",
              text: `Cancel reason registered!`,
              icon: "success",
              showConfirmButton: false,
              timer: 2500,
            });
            this.toggleModal();
            this.pageLoader(false);
            this.refresher();
          })
          .catch(() => {
            this.pageLoader(false);
          });
      }
    },
    showHoldOnModal() {
      if (this.serverData.order.last_status_id === 1340) {
        this.releaseEditForm();
      } else {
        this.dialog2 = !this.dialog2;
      }
    },
    actionOnHold() {
      if (this.holdOn_reason) {
        this.pageLoader(true);
        this.dialog2 = false;
        const data = {
          order_ids: [this.itemForAction],
          reason: this.holdOn_reason,
          scheduled_date: this.holdOn_date,
        };
        ApiService.post(
          `/order_management/pending_audit_orders/${
            this.serverData.order.last_status_id === 1340 ? "release" : "hold"
          }`,
          data
        )
          .then(() => {
            Swal.fire({
              title: "Updated",
              text: `${
                this.serverData.order.last_status_id === 1340
                  ? "Release"
                  : "Hold on"
              } reason registered!`,
              icon: "success",
              showConfirmButton: false,
              timer: 2500,
            });
            this.toggleModal();
            this.pageLoader(false);
            this.refresher();
          })
          .catch(() => {
            this.pageLoader(false);
          });
      }
    },
    setSkus(item) {
      this.formData.skus = [...item];
    },
    handleFormValidation(fieldName, dataName = "formData") {
      const errors = [];
      if (!this.$v[`${dataName}`][fieldName].$dirty) return errors;
      if ("required" in this.$v[`${dataName}`][fieldName]) {
        !this.$v[`${dataName}`][fieldName].required &&
          errors.push(this.$t("validation_this_field_is_required"));
      }
      if ("maxValue" in this.$v[`${dataName}`][fieldName]) {
        !this.$v[`${dataName}`][fieldName].maxValue &&
          errors.push("This field must be greater than 0");
      }
      if ("url" in this.$v[`${dataName}`][fieldName]) {
        !this.$v[`${dataName}`][fieldName].url &&
          errors.push(this.$t("validation_this_url_is_invalid"));
      }
      if ("numeric" in this.$v[`${dataName}`][fieldName]) {
        !this.$v[`${dataName}`][fieldName].numeric &&
          errors.push(this.$t("validation_this_must_be_a_number"));
      }
      if ("email" in this.$v[`${dataName}`][fieldName]) {
        !this.$v[`${dataName}`][fieldName].email &&
          errors.push(this.$t("validation_this_email_address_is_invalid"));
      }
      if ("sameAs" in this.$v[`${dataName}`][fieldName]) {
        !this.$v[`${dataName}`][fieldName].sameAs &&
          errors.push("This field must be same as total price");
      }
      return errors;
    },
    async loadDataFromServer() {
      this.pageLoader(true);
      let data = { id: this.itemForAction };
      await ApiService.post(`/order_management/pending_audit_orders/edit`, data)
        .then((response) => {
          this.serverData = response.data;
          this.resetEditForm().finally(() => {
            this.pageLoader(false);
            this.updateValidationStateOfSteps();
          });
        })
        .catch(() => {
          this.dialog = false;
          this.pageLoader(false);
        });
    },

    convertToFormData() {
      return this.formData;
    },
    releaseEditForm() {
      this.updateValidationStateOfSteps();
      if (this.$v.$invalid) {
        this.$v.$touch();

        return;
      }

      this.$v.$touch();
      if (this.formData.skus.length === 0) {
        Swal.fire({
          title: "Warning",
          html: `<div>At least one item should be added</div>`,
          icon: "warning",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      if (
        this.validationValueCheck("state") ||
        this.validationValueCheck("city")
      ) {
        Swal.fire({
          title: "Warning",
          html: `<div>Invalid address!</div>`,
          icon: "warning",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      this.pageLoader(true);
      let data = {
        ...this.formData,
        ...this.address,
        ...this.consignee,
        ...this.order_details,
      };
      data.state = this.address.state.id;
      data.city = this.address.city.id;
      if (this.address.area) {
        data.area = this.address.area.id;
      }

      ApiService.post(`/order_management/pending_audit_orders/release`, data)
        .then(() => {
          Swal.fire({
            title: "Updated",
            text: `Order has been updated`,
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          let id = this.serverData.order.id;
          this.showNextOrder(id);
        })
        .catch(() => {
          this.pageLoader(false);
        });
    },
    submitEditForm() {
      this.updateValidationStateOfSteps();
      if (this.$v.$invalid) {
        this.$v.$touch();

        return;
      }
      this.$v.$touch();
      if (this.formData.skus.length === 0) {
        Swal.fire({
          title: "Warning",
          html: `<div>At least one item should be added</div>`,
          icon: "warning",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      if (
        this.validationValueCheck("state") ||
        this.validationValueCheck("city")
      ) {
        Swal.fire({
          title: "Warning",
          html: `<div>Invalid address!</div>`,
          icon: "warning",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      this.pageLoader(true);
      const data = {
        ...this.formData,
        ...this.address,
        ...this.consignee,
        ...this.order_details,
      };
      if (data.payment_type !== 1) {
        data.payment_mode = null;
      }

      data.state = this.address.state.id;
      data.city = this.address.city.id;
      if (this.address.area) {
        data.area = this.address.area.id;
      }

      ApiService.post(`/order_management/pending_audit_orders/update`, data)
        .then(() => {
          Swal.fire({
            title: "Updated",
            text: `Order has been updated`,
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          let id = this.serverData.order.id;
          this.showNextOrder(id);
        })
        .catch(() => {
          this.pageLoader(false);
        });
    },
    async resetEditForm() {
      this.$v.$reset();
      const dataNames = ["formData", "consignee", "order_details"];
      if (this.serverData) {
        dataNames.forEach(async (dataName) => {
          let copy = { ...this.serverData.order };
          await Object.entries(this[`${dataName}`]).forEach((localD) => {
            Object.entries(this.serverData.order).forEach((serverD) => {
              if (localD[0] === serverD[0] && localD[0] !== "image") {
                this[`${dataName}`][localD[0]] = copy[serverD[0]];
              }
            });
          });
        });

        this.address.country_id = this.serverData.order.country_id;

        // const state = this.serverData.states.find(
        //   (state) => state.title === this.serverData.order.state
        // );
        // const city = this.serverData.citites.find(
        //   (city) => city.title === this.serverData.order.city
        // );
        // const area = this.serverData.areas.find(
        //   (area) => area.title === this.serverData.order.area
        // );
        // console.log(state, city, area);

        this.old_address = {
          state: this.serverData?.order?.state,
          city: this.serverData?.order?.city,
          area: this.serverData?.order?.area,
        };
        this.order_details.shipping_method =
          Boolean(this.serverData.order.shipping_method) === true
            ? this.serverData.order.shipping_method
            : 2;

        this.address = {
          ...this.address,
          province: this.serverData.order.province,
          town: this.serverData.order.town,
          address: this.serverData.order.address,
          short_address: this.serverData.order.short_address,
          zipcode: this.serverData.order.zipcode,
        };
        if (this.serverData.order.country_id) {
          await this.onCountryChange(
            this.serverData.order.country_id,
            true,
            true
          );

          /**
           * Check if order state is present
           * If present - check with serverData.states without case sensitivity
           */

          const capitalize = (word) =>
            word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();

          const orderState = this.serverData.order?.state;
          const orderCity = this.serverData.order?.city;
          const orderArea = this.serverData.order?.area;

          if (orderState && this.serverData?.states) {
            const isAvailabeInServer = this.serverData.states.find(
              (state) =>
                capitalize(state.title) === capitalize(orderState.trim())
            );
            if (isAvailabeInServer) {
              await this.onStateChange(isAvailabeInServer?.title);
            }
          }
          /**
           * Check if order city is present
           * If present - check with serverData.cities without case sensitivity
           */
          if (orderCity && this.serverData?.cities) {
            const isAvailabeInServer = this.serverData.cities.find(
              (city) => capitalize(city.title) === capitalize(orderCity.trim())
            );
            if (isAvailabeInServer) {
              await this.onCityChange(isAvailabeInServer?.title);
            }
          }
          /**
           * Check if order area is present
           * If present - check with serverData.areas without case sensitivity
           */
          if (this.serverData.order.area && this.serverData?.areas) {
            const isAvailabeInServer = this.serverData?.areas.find(
              (area) => capitalize(area.title) === capitalize(orderArea.trim())
            );
            this.address.area = isAvailabeInServer;
          }
        }
      } else {
        this.formData = {
          id: null,
          skus: [],
        };
        this.address = {
          address: null,
          area: null,
          province: null,
          town: null,
          city: null,
          state: null,
          country_id: null,
          zipcode: null,
          short_address: null,
        };
        this.consignee = {
          consignee_name: null,
          consignee_phone: null,
          consignee_mobile: null,
          consignee_email: null,
          consignee_document_number: null,
          consignee_document_type_id: null,
          consignee_document_country_id: null,
          consignee_document_expiry_date: null,
          consignee_document_issue_date: null,
          consignee_birthday: null,
        };
        this.order_details = {
          awb: null,
          // skip_oms_rules: false,
          warehouse: null,
          carrier_id: null,
          comment: null,
          total_price: null,
          currency: null,
          payment_type: null,
          payment_mode: 1,
          shipping_method: null,
          order_type: null,
          parcel_weight: null,
          parcel_volume: null,
          number_of_boxes: null,
          gift_message: null,

          shipping_price: null,
          total_tax: null,
          tax_percentage: null,
          subtotal: null,

          customs_value: null,
          total_discount: null,
          total_declared_amount: null,
          cod_amount: null,
        };
      }

      this.tab = 0;
      this.resetValidationStateOfSteps();
    },
    toggleModal() {
      if (this.dialog) {
        this.serverData = null;
        this.resetEditForm();
      } else {
        this.loadDataFromServer();
      }
      this.dialog = !this.dialog;
    },
    async onCountryChange(val, safe = true) {
      this.pageLoader(true);
      try {
        await handleCountryValueChange.call(this, val, safe);
        await this.updateValue("state");
      } catch {
        this.pageLoader(false);
      } finally {
        this.pageLoader(false);
      }
    },
    async onStateChange(value, safe = true, is_id = false) {
      // clearTimeout(this.cityFetchTimer);
      // this.cityFetchTimer = setTimeout(async () => {
      this.pageLoader(true);
      try {
        await handleStateValueChange.call(this, value, safe, is_id);
        await this.updateValue("city");
      } catch {
        this.pageLoader(false);
      } finally {
        this.pageLoader(false);
      }
      // }, this.locationFetchTriggerTime);
    },
    async onCityChange(value, safe = true, is_id = false) {
      // clearTimeout(this.areaFetchTimer);
      // this.areaFetchTimer = setTimeout(async () => {
      this.pageLoader(true);
      try {
        await handleCityValueChange.call(this, value, safe, is_id);
        this.areaMessageGenerator();
      } catch {
        this.pageLoader(false);
      } finally {
        this.pageLoader(false);
      }
      // }, this.locationFetchTriggerTime);
    },
    async copyAddress(address) {
      if (address) {
        await navigator.clipboard.writeText(address);
        this.snackbarText = `${address} is copied to clipboard`;
        this.snackbar = true;
      } else {
        await navigator.clipboard.writeText("");
      }
    },
  },

  computed: {
    categories() {
      return [
        {
          name: "Status History",
          valid: true,
          rules: () => {
            return false;
          },
        },
        {
          name: "Consignee Details",
          valid: true,
          rules: (el) => {
            try {
              return el[`$v`][`consignee`].$invalid;
            } catch {
              return true;
            }
          },
        },
        {
          name: "Order Details",
          valid: true,
          rules: (el) => {
            try {
              return el[`$v`][`order_details`].$invalid;
            } catch {
              return true;
            }
          },
        },
        {
          name: "Call History",
          valid: true,
          rules: () => {
            return false;
          },
        },
        {
          name: "Address",
          valid: true,
          rules: (el) => {
            try {
              return el[`$v`][`address`].$invalid;
            } catch {
              return true;
            }
          },
        },
        {
          name: "Current Status",
          valid: true,
          rules: () => {
            return false;
          },
        },
        {
          name: "Items",
          valid: true,
          rules: (el) => {
            try {
              return !el.formData.skus.length > 0;
            } catch {
              return true;
            }
          },
        },
      ];
    },
    getLocationType() {
      return this.location_type;
    },
    getLocationId() {
      return this.locaiton_id;
    },
    getLocationFunc() {
      return this.location_function;
    },
    getLocationInitValue() {
      return this.location_initValue;
    },
    isStepperReady() {
      try {
        return !!this.$v;
      } catch (error) {
        return false;
      }
    },
    states: function () {
      return this.serverData.states;
    },
    cities: function () {
      return this.serverData.cities;
    },
    areas: function () {
      return this.serverData.areas;
    },
    isStatesLoaded: function () {
      return !this.serverData.states;
    },
    isCitiesLoaded: function () {
      return !this.serverData.cities;
    },
    isAreasLoaded: function () {
      return !this.serverData.areas;
    },
    isDataLoadedFromServer: function () {
      return !!this.serverData;
    },
    infoData() {
      return this.serverData.data;
    },
    // order_typeErrors: function() {
    //   return this.handleFormValidation("order_type", "order_details");
    // },
    currencyErrors: function () {
      return this.handleFormValidation("currency", "order_details");
    },
    payment_typeErrors: function () {
      return this.handleFormValidation("payment_type", "order_details");
    },
    payment_modesErrors: function () {
      return this.handleFormValidation("payment_mode", "order_details");
    },
    shipping_methodErrors: function () {
      return this.handleFormValidation("shipping_method", "order_details");
    },
    total_priceErrors: function () {
      return this.handleFormValidation("total_price", "order_details");
    },
    parcel_weightErrors: function () {
      return this.handleFormValidation("parcel_weight", "order_details");
    },
    parcel_volumeErrors: function () {
      return this.handleFormValidation("parcel_volume", "order_details");
    },
    number_of_boxesErrors: function () {
      return this.handleFormValidation("number_of_boxes", "order_details");
    },
    cod_amountErrors: function () {
      return this.handleFormValidation("cod_amount", "order_details");
    },
    consignee_nameErrors: function () {
      return this.handleFormValidation("consignee_name", "consignee");
    },
    consignee_phoneErrors: function () {
      return this.handleFormValidation("consignee_phone", "consignee");
    },
    consignee_mobileErrors: function () {
      return this.handleFormValidation("consignee_mobile", "consignee");
    },
    addressErrors: function () {
      return this.handleFormValidation("address", "address");
    },
    cityErrors: function () {
      return this.handleFormValidation("city", "address");
    },
    areaErrors: function () {
      return this.handleFormValidation("area", "address");
    },
    country_idErrors: function () {
      return this.handleFormValidation("country_id", "address");
    },
    stateErrors: function () {
      return this.handleFormValidation("state", "address");
    },
  },
  watch: {
    state_text: {
      handler(value, oldValue) {
        if (!this.serverData.countries) {
          this.serverData.states = null;
          this.serverData.cities = null;
          this.serverData.areas = null;
          return;
        }
        if (value == "" || value == null || value == undefined) {
          return;
        }
        if (value == oldValue) {
          return;
        }
        this.updateValue("state");
      },
      deep: true,
    },
    city_text: {
      handler(value, oldValue) {
        if (!this.serverData.states) {
          this.serverData.cities = null;
          this.serverData.areas = null;
          return;
        }
        if (value == "" || value == null || value == undefined) {
          return;
        }
        if (value == oldValue) {
          return;
        }
        this.updateValue("city");
      },
      deep: true,
    },
    // "address.country_id": function (newVal, oldVal) {
    //   console.log(`country_id changed from ${oldVal} to ${newVal}`);
    //   // Add your logic here
    // },
  },
};
</script>

<style scoped>
.modal-body {
  height: 100%;
  align-content: flex-end;
}

.modal-root {
  background-color: white !important;
  height: 100%;
}

.modal-action {
  justify-self: flex-end;
  height: 100%;
}

.form-body {
  max-height: 80vh !important;
  height: 80vh !important;
  overflow-y: scroll;
}

.step-head {
}

.step-head-main {
  display: flex;
  flex-flow: row;
  overflow-x: scroll;
  overflow-y: hidden;
  width: 100%;
  height: 100%;
}
</style>
